import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Session} from './Session';
import {FormulaTestCaseService} from '../tpiq-services/formula-test-case.service';

@Injectable({
  providedIn: 'root'
})
export class InternalOnlyActivator implements CanActivate {
  constructor(private router: Router, private formulaTestCaseService: FormulaTestCaseService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    if (!Session.hasSession() || Session.isSessionExpired()) {
      Session.setLastVisitedUrl(state.url);
      return of(this.router.createUrlTree(['/login']));
    }

    return this.formulaTestCaseService.checkInternalAccess(Session.getOrg(), Session.getUser().id).pipe(
      map((response: any) => response && response.internal ? true : this.router.createUrlTree(['/'])),
      catchError(() => of(this.router.createUrlTree(['/'])))
    );
  }
}
